import { Info } from 'lucide-react';
import * as React from 'react';

import { Tooltip, type TooltipProps } from '../tooltip';

export interface InfoTooltipProps extends Omit<TooltipProps, 'children'> {
  /** Accessible name for the info trigger button. */
  'aria-label'?: string;
}

/**
 * Circled info icon with a dark hover tooltip — the shared pattern used beside
 * Field labels (e.g. Source on File Upload) and other help affordances.
 */
export const InfoTooltip = React.forwardRef<HTMLButtonElement, InfoTooltipProps>(function InfoTooltip(props, ref) {
  const { content, 'aria-label': ariaLabel = 'More information', ...tooltipProps } = props;
  return (
    <Tooltip content={content} {...tooltipProps}>
      <button
        ref={ref}
        type="button"
        aria-label={ariaLabel}
        style={{
          display: 'inline-flex',
          cursor: 'help',
          color: 'var(--ks-colors-neutral-300)',
          background: 'none',
          border: 'none',
          padding: 0,
          margin: 0,
          lineHeight: 0,
          verticalAlign: 'middle',
        }}
        onMouseDown={e => e.preventDefault()}
      >
        <Info size={14} aria-hidden />
      </button>
    </Tooltip>
  );
});
